export function loginWith(provider) {
    window.open(`/login-with/${provider}/`, "_self").focus();
}

export function registerWith(provider, gender, genderSearch) {
    window
        .open(`/login-with/${provider}/${gender}/${genderSearch}`, "_self")
        .focus();
}
